import React, { useEffect } from 'react';
import './MainHomeContainer.css';
import MenImg from '../../Images/HomeImages/HomeManCleaing.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
function MainHomeContainer() {
    useEffect(() => {
        AOS.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
    }, []);
    return (
        <>
            <div className="main-home-section">
                <div className="main-home-overlay">
                    <div className="main-home-content special-content" data-aos="fade-right" >
                        <h4>Affordable for Everyone</h4>
                        <h2>Ultimate Cleaning <br /> Services For You</h2>
                        <p>
                            Affordable for Everyone Top-Quality Cleaning Services Experience a spotless space with our expert touch. We bring care and precision to every corner, ensuring a perfect clean.
                        </p>
                        <div className="main-home-buttons">
                            <a href="#MainHome-services-container"><button className="contact-us-button">VIEW SERVICES</button></a>
                        </div>
                    </div>
                    <div className="main-home-side-image">
                        <img src={MenImg} alt="Main Home Image" data-aos="fade-left" />
                    </div>
                </div>
                <div class="custom-shape-divider-bottom-1739127441">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
                    </svg>
                </div>
            </div>

        </>
    );
}

export default MainHomeContainer;
